// Sidebar.js
// Collapsible sidebar listing available chart types

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem, Button } from '@blueprintjs/core';

// Component Class
// Renders the list of chart options inside the sidebar panel
class Sidebar extends React.Component {
  // Renders Component
  render() {
    const { isOpen, charts, selectedChart, onSelect, onToggle } = this.props;
    return (
      <div className={`chart-sidebar${isOpen ? ' chart-sidebar--open' : ''}`}>
        <div className="chart-sidebar__header">
          <Button
            className="chart-sidebar__toggle"
            icon={isOpen ? 'menu-open' : 'menu-closed'}
            onClick={onToggle}
            title={isOpen ? 'Recolher menu' : 'Expandir menu'}
            id="sidebar-toggle"
            minimal={true}
          />
        </div>
        <Menu className="chart-sidebar__list">
          {charts.map(chart => (
            <MenuItem
              key={chart.id}
              active={selectedChart === chart.id}
              onClick={() => onSelect(chart.id)}
              text={isOpen ? chart.label : undefined}
              icon={chart.icon}
              title={!isOpen ? chart.label : undefined}
              className={selectedChart === chart.id ? "chart-sidebar__item--active" : ""}
            />
          ))}
        </Menu>
      </div>
    );
  }
}

// Required Properties
Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  charts: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, label: PropTypes.string, icon: PropTypes.string })
  ).isRequired,
  selectedChart: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
};

// Exports
export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/ChartView/Sidebar.js